<template>
  <div class="login">
    <vue-particles class="bg" color="#dedede"></vue-particles>
    <div class="box">
      <div class="title">登录</div>
      <div class="main">
        <el-form class="form" label-width="80px">
          <el-form-item label="公司代码">
            <el-input v-model="com" placeholder="请输入公司代码"></el-input>
          </el-form-item>
          <el-form-item label="账号">
            <el-input class="code" v-model="code" placeholder="请输入登录账号"></el-input>
          </el-form-item>

          <el-form-item label="密码">
            <el-input :type="passwordType" class="pwd" v-model="pwd" placeholder="请输入登录密码，区分大小写"></el-input>
            <div class="show-pwd" @click="showPwd">
              <svg-icon icon-class="eye" />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="action">
        <el-button type="primary" style="width:200px" @click="doLogin">登录</el-button>
      </div>
      <div style="margin-top: 40px; color:#999; font-size: 14px">
        <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备2025229490号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      com: '',
      code: '',
      pwd: '',
      passwordType: 'password',
      back: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.back = query.back
        }
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    doLogin() {
      const _t = this
      const data = {
        com: _t.com.trim(),
        code: _t.code.trim(),
        pwd: _t.pwd.trim()
      }
      if (data.code == '') {
        _t.$message.error('请输入账号')
        return
      }
      if (data.pwd == '') {
        _t.$message.error('请输入密码')
        return
      }

      _t.$store.dispatch('user/login', data).then(resp => {
        if (resp.code == 0) {
          _t.$router.push({ path: _t.back || '/' })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  background: url('~@/assets/bg_login.jpg');
  background-size: cover;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.login {
  text-align: center;
}
.box {
  max-width: 400px;
  margin: 150px auto 0 auto;
  padding: 40px 20px;
  background: #fff;
  opacity: .8;
  border-radius: 5px;
  z-index: 100;
  position: relative;
  .title {
    font-size: 20px;
    margin: 0 0 20px 0;
  }
  .form {
    width: 100%;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .main {
    margin: 40px 0;
  }
}
</style>

